import * as React from 'react';
import { Draggable } from '@hello-pangea/dnd';
import styled from 'styled-components';
import { otherFieldName } from '../../../core/constants';
import Input from '../../appForm/Input';
import { blackColour, whiteColour } from '../../../appComponents/cssConstants';

const Option = (props: Props) => {
	return (
		<Draggable draggableId={props.option.id} index={props.index} isDragDisabled={props.isDragDisabled}>
			{(provided, snapshot) => (
				<Container
					{...provided.draggableProps}
					{...provided.dragHandleProps}
					ref={provided.innerRef}
					$isDragging={snapshot.isDragging}
					$isDragDisabled={props.isDragDisabled}
				>
					{props.option.content}
					{props.option.showOtherTextField && props.isMovedToNewColumn && (
						<StyledInput
							label="Other (Please specify)"
							name={otherFieldName}
							required
							onBlur={(e: any) => props.onValueChange(e.target.value)}
						/>
					)}
				</Container>
			)}
		</Draggable>
	);
};

export default Option;

interface Props {
	option: any;
	index: number;
	isDragDisabled: boolean;
	onValueChange: (value: string) => void;
	isMovedToNewColumn: boolean;
}

const Container = styled.div<{ $isDragging: boolean; $isDragDisabled: boolean }>`
	border: 1px solid lightgray;
	border-radius: 26px;
	padding: 8px;
	margin-bottom: 8px;
	padding: 16px 24px;
	font-size: 18px;
	line-height: 21px;
	background-color: ${(props) =>
		// eslint-disable-next-line no-nested-ternary
		props.$isDragDisabled ? 'lightgray' : props.$isDragging ? props.theme.brandingColourHeavy : 'white'};
	color: ${(props) => (props.$isDragging ? whiteColour : blackColour)};
	display: flex;
	flex-direction: column;
`;

const StyledInput = styled(Input)`
	margin: 5px 0 0 0;
	width: 100%;
`;
